import { render, staticRenderFns } from "./WTopBar.vue?vue&type=template&id=19bde11a&scoped=true&"
import script from "./WTopBar.vue?vue&type=script&lang=js&"
export * from "./WTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bde11a",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WDropdownMenu from '@/components/WDropdownMenu.vue'
autoInstallComponents(component, {WDropdownMenu})
